(function($) {
  const homepageContent = document.querySelector(".homepage-careers");
  /**
   * @description - Function checks if element is in the viewport and adds appropriate class to it.
   */
  const showContentWhenInViewport = debounce(() => {
    if (homepageContent && isInViewport(homepageContent)) {
      homepageContent.classList.add("in-viewport");
    }
  }, 30);

  /**
   * Initialize functions on start and on scroll
   */
  $(document).ready(() => {
    showContentWhenInViewport();
  });

  $(window).on("scroll touchmove", () => {
    showContentWhenInViewport();
  });
})(jQuery);
